import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import { TextInput } from '@ui/components/core/TextInput'
import { DynamicFormProps } from '@ui/interfaces'
import { isValidUrl } from '@ui/lib/helpers/validationHelpers'
import { SaveAndCancelButtons } from '@ui/pages/pipelinesWorkflow/components/DestinationForms/SaveAndCancelButtons'
import * as Yup from 'yup'

const schema = Yup.object({
  host: Yup.string().test('is-url-valid', 'Host is not valid', isValidUrl).required('Host must be provided'),
  port: Yup.string().required('Port must be provided'),
  apiKey: Yup.string().required('API Key is required'),
  dataset: Yup.string(),
}).required()

export default function Honeycomb(props: DynamicFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      ...props.config,
      host: 'https://api.honeycomb.io',
      port: '443',
    },
  })

  const { saveClick, cancelClick } = props

  return (
    <form onSubmit={handleSubmit(saveClick)}>
      {props.additionalInputs}
      <div>
        <TextInput
          label="Host*"
          placeholder="https://api.honeycomb.io"
          disabled={props.disableInputs}
          register={register}
          name="host"
          error={errors['host']?.message}
        />
        <TextInput
          label="Port*"
          placeholder="443"
          disabled={props.disableInputs}
          register={register}
          name="port"
          error={errors['port']?.message}
        />
        <TextInput
          label="API Key*"
          placeholder="YOUR_API_KEY"
          disabled={props.disableInputs}
          register={register}
          name="apiKey"
          error={errors['apiKey']?.message}
        />
        <TextInput
          label="Metrics Dataset"
          placeholder="YOUR_METRICS_DATASET"
          disabled={props.disableInputs}
          register={register}
          name="dataset"
          error={errors['dataset']?.message}
        />
        {props.submitButton ? props.submitButton : <SaveAndCancelButtons cancelClick={cancelClick} />}
      </div>
    </form>
  )
}
